let PDFMake;
export default async function getPDFMake() {
    if (PDFMake) return PDFMake;

    let pdfMake = await import('pdfmake/build/pdfmake')
    let pdfFonts = await import('pdfmake/build/vfs_fonts')
    pdfMake = pdfMake.default
    pdfFonts = pdfFonts.default
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    PDFMake = pdfMake;
    return PDFMake;
}
